<glxy-form-field size="small" *ngIf="editions">
  <mat-select
    data-cy="select-product-edition-dropdown"
    [value]="selectedEditionId"
    (selectionChange)="handleEditionChange($event)"
  >
    <mat-select-trigger>
      <ng-container *ngIf="selectedEditionId | findItemEdition: editions as edition">
        <span class="active-edition-label">
          {{ edition?.name }}
          <ng-container *ngIf="edition?.isActive">
            <glxy-badge [size]="'small'" [color]="'blue'">
              {{ 'ACTIVE_ITEMS.STATUS.ACTIVE' | translate }}
            </glxy-badge>
          </ng-container>
        </span>
      </ng-container>
    </mat-select-trigger>
    <mat-option
      data-cy="edition-option"
      *ngFor="let edition of editions"
      [disabled]="edition?.isActive"
      [value]="edition?.editionId"
    >
      {{ edition?.name }}
      <ng-container *ngIf="edition?.isActive">
        <glxy-badge [size]="'small'" [color]="'blue'">
          {{ 'ACTIVE_ITEMS.STATUS.ACTIVE' | translate }}
        </glxy-badge>
      </ng-container>
    </mat-option>
  </mat-select>
</glxy-form-field>
